'use strict';
const PageTypeMap = require('../../../../../../app_bata_sfra/cartridge/client/default/js/analytics/analytics-mapping');

var events = require('../../../../../../app_bata_sfra/cartridge/client/default/js/analytics/analytics-events');
var utils = require('./analytics-utils');
require('./analytics-listener');

//Global variable used by analytics
window['dataLayer'] = window['dataLayer'] || [];
window.bata_com_ns = window.bata_com_ns || {};
window.bata_com_ns.analytics = window.bata_com_ns.analytics || {};

/**
 * @description launch the product (PDP) impression
 */
function triggerProductsImpressions(pageType) {
    var products;
    var ga4Products;
    if (pageType === 'product') {
        products = utils.getProductDataPDP();
        ga4Products = utils.ga4GetProducts(products);
        let value = ga4Products && ga4Products.length > 0 ? ga4Products[0].price : 0;
        utils.promoImpressionHelper();
        events.ga4ViewItem(window.bata_com_ns.analytics.currency, ga4Products, parseFloat(value));
    } else if (pageType === 'cart') {
        products = utils.getProductsCartData(pageType);
        ga4Products = utils.ga4GetProducts(products);
        let cartPageData = utils.ga4GetCartData();
        events.ga4ViewCart(window.bata_com_ns.analytics.currency, ga4Products, cartPageData.couponNames, parseFloat(cartPageData.value));
    } else {
        products = utils.getProductsData();
        ga4Products = utils.ga4GetProducts(products);
        // track GA4 product views only if not empty
        if (ga4Products && ga4Products.length > 0) {
            events.ga4ViewItemList(window.bata_com_ns.analytics.currency, ga4Products);
        }
    }
    // track UA product views only if not empty
    if (products && products.length > 0) {
        events.trackProductImpression(window.bata_com_ns.analytics.currency, products);
    }
    utils.trackRecommendationsLists();
}

/**
 * @description when editorial products on PDP, handle the data and trigger view_item_list GA4 event
 */
function triggerEditorialProducts() {
    let productsList = [];
    let currentProductId = utils.getProductDataPDP()[0].id || 'undefined product';
    let editorialProducts = $('.js-editorial-pdp .product-tile.js-tileWrapper');
    let sectionTitle = $('.js-editorial-pdp .cc-recommended-slider__title-link').text().trim() || 'Editorial PDP';

    if (editorialProducts.length > 0) {
        editorialProducts.each(function () {
            let analyticsProduct = $(this).find('.analytics-product');
            if (analyticsProduct.data('name') && analyticsProduct.data('id')) {
                let productData = utils.getProductClickTileData(analyticsProduct);
                productData.list_name = `PDP - ${currentProductId} - ${sectionTitle}`;
                productsList.push(productData);
            }
        });
        if (productsList.length > 0) {
            let ga4ProductsList = utils.ga4GetProducts(productsList);
            events.ga4ViewItemList(window.bata_com_ns.analytics.currency, ga4ProductsList);
        }
    }
}

/**
 * @description get all the global information form the DOM, then eventually, lauch the various impressions
 */
function pushPageData() {
    let $user = $('#analytics-user');
    let pageType = utils.getPageType();
    let customerEmailMarketing = $user.data('email-marketing').toString();
    let customerEmail = $user.data('email');
    let customerCrmId = $user.data('customer-crm-id');
    let customerGender = $user.data('user-gender');
    let customerId = $user.data('customerid');
    let customerType = ($user.data('order-count') > 0) ? 'existing' : 'new';
    let currency = $('#analyticsCurrencyCode').data('currency');
    let countryCode = $('#analytics-countryCode').data('content');

    // pageType should always be set at least to 'other'
    pageType = pageType && pageType.length > 0 ? pageType : 'other';

    //saves useful information in window object to improve the performances
    window.bata_com_ns.analytics.currency = currency;
    window.bata_com_ns.analytics.pageType = pageType;
    window.bata_com_ns.analytics.country = countryCode;

    window.bata_com_ns.abTests = {
        callAbTestInteraction: utils.callAbTestInteraction
    };

    // businessHours event
    events.businessHours(utils.getBusinessHours());

    // abTests data pushing into the dataLayer
    utils.callAbTestInteraction({'pageType': pageType});

    //If the pageType is detected, track the page impression
    if (pageType) {
        events.pageImpression(customerCrmId, pageType, window.location.href, customerEmail);
        let ga4CrmId = customerCrmId && customerCrmId !== 'guest' ? customerCrmId : null;
        let ga4Email = customerEmail && customerEmail !== 'guest' ? customerEmail : null;

        events.ga4PageView({
            pageType: pageType,
            pageURL: window.location.origin,
            pagePath: window.location.pathname,
            country: countryCode,
            emailMarketing: customerEmailMarketing,
            email: ga4Email || undefined,
            internalClientId: customerId,
            loginStatus: ga4CrmId ? 'true' : 'false',
            gender: customerGender,
            userID: ga4CrmId || undefined,
            userType : ga4CrmId ? customerType : "guest"
        });
        utils.PageDesignerPromoImpressionHelper();
    }
    //if the pageType can contains products to track the impressions, trigger the event
    if (PageTypeMap.PRODUCT_IMPRESSION_MAPPING[pageType]) {
        triggerProductsImpressions(pageType);
        if (pageType === 'product') {
            triggerEditorialProducts();
        }
    }
    //if it is a category or brand page, try to get search data
    if (pageType === 'category' || pageType === 'brands') {
        utils.searchHelper();
    } else if (pageType === 'purchase') {
        //if the user lands on purchase page, launch checkout events
        utils.orderConfirmHelper();
    }

    // At cart page check for removed items due to unavailability
    if (pageType === 'cart' && $('#unavailableProductsModal').length > 0) {
        utils.removeFromCartByUnavailabilityModal();
    }
    window.dataLayer.push({'event': 'basicAppEventsInitialized'});
}

/**
 * Observe lazy-loaded product components and track them in analytics
 */
function observeLazyLoadedProducts() {
    // Create a mutation observer to watch for added product lists
    const observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
            if (mutation.addedNodes && mutation.addedNodes.length) {
                for (let i = 0; i < mutation.addedNodes.length; i++) {
                    const node = mutation.addedNodes[i];

                    // Skip non-element nodes, they can't contain product lists
                    // https://developer.mozilla.org/en-US/docs/Web/API/Node/nodeType
                    if (node.nodeType !== 1) {
                        continue;
                    }

                    // Check if this node is a product list or contains product lists
                    const $productLists = $(node).hasClass('analytics-ProductList')
                        ? $(node)
                        : $(node).find('.analytics-ProductList');

                    if ($productLists.length) {
                        // Process products in the list
                        const products = utils.getProductsData();

                        if (products && products.length > 0) {
                            const ga4Products = utils.ga4GetProducts(products);

                            if (ga4Products && ga4Products.length > 0) {
                                events.ga4ViewItemList(window.bata_com_ns.analytics.currency, ga4Products);
                            }

                            events.trackProductImpression(window.bata_com_ns.analytics.currency, products);
                        }

                        // Process any recommendation lists
                        utils.trackRecommendationsLists();

                    }
                }
            }
        });
    });

    // Start observing the document for changes
    observer.observe(document.body, {
        childList: true,
        subtree: true
    });
}

$(document).ready(function () {
    pushPageData();
    observeLazyLoadedProducts();
});



// WEBPACK FOOTER //
// ./cartridges/app_checkout_redesign/cartridge/client/default/js/analytics/analytics-index.js